/**
 * Layout: tiene il margine inferiore di #MainContent allineato all'altezza del footer,
 * che cambia quando gli embed asincroni (es. form Klaviyo) finiscono di caricarsi.
 * Gestisce anche lo scroll a #ContactFooter arrivando da un link esterno.
 *
 * Era inline in snippets/scripts.liquid. Le letture di layout restano batchate in un
 * rAF; il ResizeObserver copre ogni cambio di altezza, quindi il MutationObserver
 * resta solo come fallback per browser senza ResizeObserver (prima girava sempre e
 * scattava anche sulle mutazioni che non cambiano l'altezza).
 */
(function () {
	var main = document.getElementById('MainContent');
	var footer = document.querySelector('.section__footer');

	if (window.location.hash === '#ContactFooter' && document.getElementById('ContactFooter')) {
		setTimeout(function () {
			window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
		}, 100);
	}

	if (!main || !footer) return;

	var rafId = null;
	function scheduleUpdate() {
		if (rafId) cancelAnimationFrame(rafId);
		rafId = requestAnimationFrame(function () {
			main.style.marginBottom = Math.ceil(footer.getBoundingClientRect().height) + 'px';
			rafId = null;
		});
	}

	scheduleUpdate();

	if (window.ResizeObserver) {
		new ResizeObserver(scheduleUpdate).observe(footer);
	} else if (window.MutationObserver) {
		new MutationObserver(scheduleUpdate).observe(footer, { childList: true, subtree: true });
	}

	window.addEventListener('resize', scheduleUpdate);
	setTimeout(scheduleUpdate, 2000);
})();
